module.exports = __webpack_public_path__ + "img/case2.094cef6f.png";